import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Loader from '../UI/Loader'
import tools from '../../tools'
import { XCircleIcon, LocationMarkerIcon, UserCircleIcon, PlusSmIcon, PencilAltIcon, TrashIcon } from '@heroicons/react/solid'
import './Services.css'
import ReactBodymovin from 'react-bodymovin'
import animation from '../../img/check-circle.json'
import Checkout from './Checkout'
import PaymentChoice from './PaymentChoice'

class Booking extends Component {
	constructor(props) {
		super(props)
		this.state = {
			reservation: this.props.reservation,
			answers: [],
			step: 0,
			curr: null,
			service: null,
			checkout: null,
			payment_choice: false,
			stripeError: null,
			question_nb: 0,
			user: {
				client_number: null,
				identity: null,
				age: null,
				phone: null
			},
			form1: {
				self: true,
				participants: []
			},
			form2: {
				day: '',
				month: '',
				year: '',
			},
			form3: {
				phone: ''
			},
			participants: [],
			attempt_submit: false,
			error: this._initErrors(),
			addingParticipant: false,
			editingParticipant: null,
			newParticipant: { firstname: '', lastname: '' },
			stepHistory: [],
			from_recap: false
		}
		this.length_max = 40
		if (this.props.user.from === "dashboard")
		{
			this.state.user.client_number = 0
			this.state.user.identity = "Test Test"
			this.state.user.age = 42
			this.state.user.phone = "123456"
		}
		else
		{
			this.state.user.client_number = this.props.user.client_number
			let identity = ""
			if (this.props.user.civility && this.props.user.civility.length > 0)
			{
				if (this.props.user.civility === "femme")
					identity = "Mme. "
				else if (this.props.user.civility === "homme")
					identity = "Mr. "
			}
			identity += this.props.user.firstname + " " + this.props.user.lastname
			this.state.user.identity = identity
			let age = null
			const date = new Date()
			if (this.props.user.birthday && this.props.user.birthday.length > 0)
			{
				const day = Number(this.props.user.birthday.substr(0, 2))
				const month = Number(this.props.user.birthday.substr(3, 2)) - 1
				const year = Number(this.props.user.birthday.substr(6, 4))
				age = date.getFullYear() - year
				if (month > date.getMonth() || (month === date.getMonth() && day > date.getDate()))
					age--
			}
			this.state.user.age = age
			this.state.user.phone = this.props.user.phone
		}
	}

	componentDidMount() {
		if (this.props.updateCustomBack)
			this.props.updateCustomBack(this.props.onExitBooking || null)
		const infos = {
			service: this.props.service_benefit.service,
			service_benefit: this.props.service_benefit._id
		}
		this.props.updateLogs(this.props.pathname, 'Services', infos)
		let answers = []
		const service_benefit = this.props.service_benefit
		for (let i = 0; i < service_benefit.questions.length; i++)
			answers.push('')
		this.setState({ answers: answers })
		// Service parent : nécessaire pour connaître son mode de paiement in-app.
		if (this.props.fetchServiceByID && service_benefit.service)
		{
			this.props.fetchServiceByID(service_benefit.service)
			.then(service => {
				this.setState({ service: service })
			})
			.catch(err => {
				console.log(err)
			})
		}
	}

	setErrorMsg = (msg) => {
		this.setState({ error: msg })
	}

	clearFlash = () => {
		this.setState({ error: null })
	}

	_initErrors = () => {
		const errors = {
			global: null,
			firstname: [],
			lastname: []
		}
		if (this.state)
		{
			for (let i = 0; i < this.state.form1.participants.length; i++)
			{
				errors.firstname.push(null)
				errors.lastname.push(null)
			}
		}
		return errors
	}

	handleSelf = () => {
		const form1 = {
			...this.state.form1,
			self: (this.state.form1.self === true) ? false : true
		}
		this.setState({ form1: form1 })
	}

	// --- Inline add participant ---

	startAddParticipant = (event) => {
		event.preventDefault()
		this.setState({ addingParticipant: true, newParticipant: { firstname: '', lastname: '' } })
	}

	cancelAddParticipant = () => {
		this.setState({ addingParticipant: false, newParticipant: { firstname: '', lastname: '' } })
	}

	handleNewFirstname = (event) => {
		this.setState({ newParticipant: { ...this.state.newParticipant, firstname: event.target.value } })
	}

	handleNewLastname = (event) => {
		this.setState({ newParticipant: { ...this.state.newParticipant, lastname: event.target.value } })
	}

	submitNewParticipant = () => {
		const { firstname, lastname } = this.state.newParticipant
		if (firstname.trim().length === 0 || lastname.trim().length === 0)
			return
		const participants = [...this.state.form1.participants, { firstname: firstname.trim(), lastname: lastname.trim() }]
		const form1 = { ...this.state.form1, participants: participants }
		this.setState({ form1: form1, addingParticipant: false, newParticipant: { firstname: '', lastname: '' } })
	}

	// --- Inline edit participant ---

	cancelEditParticipant = () => {
		this.setState({ editingParticipant: null })
	}

	deleteParticipant = (participant_k, event) => {
		event.preventDefault()
		let participants = this.state.form1.participants
		participants.splice(participant_k, 1)
		const form1 = {
			...this.state.form1,
			participants: participants
		}
		this.setState({ form1: form1, editingParticipant: null })
	}

	handleLastname = (participant_k, event) => {
		event.preventDefault()
		const participants = this.state.form1.participants
		participants[participant_k].lastname = event.target.value
		const form1 = {
			...this.state.form1,
			participants: participants
		}
		this.setState({ form1: form1 })
	}

	handleFirstname = (participant_k, event) => {
		event.preventDefault()
		const participants = this.state.form1.participants
		participants[participant_k].firstname = event.target.value
		const form1 = {
			...this.state.form1,
			participants: participants
		}
		this.setState({ form1: form1 })
	}

	goToBookingMenu = () => {
		this.setState({ step: 0 })
	}

	goToStep = (nextStep, extraState = {}) => {
		if (nextStep >= 1 && nextStep <= 4)
			this.props.updateCustomBack(this.goBack)
		else
			this.props.updateCustomBack(this.props.onExitBooking || null)
		this.setState(prev => ({
			step: nextStep,
			stepHistory: [...prev.stepHistory, prev.step],
			...extraState
		}))
	}

	componentWillUnmount() {
		if (this.props.updateCustomBack)
			this.props.updateCustomBack(null)
	}

	goBack = () => {
		if (this.state.step === 3 && this.state.question_nb > 0) {
			this.setState({ question_nb: this.state.question_nb - 1 })
		} else {
			const history = [...this.state.stepHistory]
			const previousStep = history.pop()
			const targetStep = previousStep !== undefined ? previousStep : 0
			if (targetStep >= 1 && targetStep <= 4)
				this.props.updateCustomBack(this.goBack)
			else
				this.props.updateCustomBack(this.props.onExitBooking || null)
			this.setState({ step: targetStep, stepHistory: history, question_nb: 0 })
		}
	}

	_validateForm1 = () => {
		const self = this.state.form1.self
		const participants = []
		const error_obj = this._initErrors()
		let error = false
		for (let i = 0; i < this.state.form1.participants.length; i++)
		{
			const firstname = this.state.form1.participants[i].firstname
			const lastname = this.state.form1.participants[i].lastname
			if (firstname.length > this.length_max)
			{
				error = true
				error_obj.firstname[i] = "Le prénom ne doit pas dépasser " + this.length_max + " caractères"
			}
			if (firstname.length === 0 && lastname.length > 0)
			{
				error = true
				error_obj.firstname[i] = "Veuillez indiquer le prénom"
			}
			if (lastname.length > this.length_max)
			{
				error = true
				error_obj.lastname[i] = "Le nom ne doit pas dépasser " + this.length_max + " caractères"
			}
			if (lastname.length === 0 && firstname.length > 0)
			{
				error = true
				error_obj.lastname[i] = "Veuillez indiquer le nom"
			}
			if (firstname.length > 0 && firstname.length <= this.length_max &&
				lastname.length > 0 && lastname.length <= this.length_max)
			{
				participants.push({
					firstname: firstname,
					lastname: lastname
				})
			}
		}
		if (participants.length === 0 && self === false)
		{
			error = true
			error_obj.global = "Vous devez sélectionner au moins 1 participant"
		}
		if (error === true)
			this.setState({ error: error_obj })
		return (!error) ? participants : false
	}

	submitParticipants = (event) => {
		event.preventDefault()
		const participants = this._validateForm1()
		if (participants !== false)
		{
			let step = 0
			if (this.props.service_benefit.age === true && !this.state.user.age)
				step = 1
			else if (this.props.service_benefit.phone === true && !this.state.user.phone)
				step = 2
			else if (this.props.service_benefit.questions.length > 0)
				step = 3
			else
				step = 4
			this.goToStep(step, { error: this._initErrors(), participants: participants })
		}
	}

	handleDay = (event) => {
		let input = event.target.value
		const day = Number(event.target.value)
		if ((day >= 10 && day <= 31) || ((day >= 1 && day <= 3) && (input.length === 2)) || (day >= 4 && day < 10))
			document.getElementById('month').focus()
		if (day >= 4 && day < 10)
			input = '0' + input
		const form2 = {
			...this.state.form2,
			day: input
		}
		this.setState({ form2: form2 })
	}

	handleMonth = (event) => {
		let input = event.target.value
		const month = Number(event.target.value)
		if ((month >= 2 && month <= 12) || input === '01')
			document.getElementById('year').focus()
		if (month >= 2 && month <= 9)
			input = '0' + input
		const form2 = {
			...this.state.form2,
			month: input
		}
		this.setState({ form2: form2 })
	}

	handleYear = (event) => {
		const form2 = {
			...this.state.form2,
			year: event.target.value
		}
		this.setState({ form2: form2 })
	}

	_validateForm2 = () => {
		let error_obj = this._initErrors()
		let error = false
		let today = new Date()
		let currentyear = today.getFullYear()
		const day = this.state.form2.day
		const day_parsed = parseInt(day)
		const month = this.state.form2.month
		const month_parsed = parseInt(month)
		const year = this.state.form2.year
		const year_parsed = parseInt(year)
		if (!day && !month && !year)
		{
			error_obj.global = "Veuillez renseigner votre date de naissance !"
			error = true
		}
		else if (!day || (day_parsed <= 0 || day_parsed >= 32))
		{
			error_obj.global = "Oups, cette date n'est pas valide"
			error = true
		}
		else if (!month || (month_parsed <= 0 || month_parsed >= 13))
		{
			error_obj.global = "Oups, ce mois n'est pas valide"
			error = true
		}
		else if (!year || (year_parsed <= 1900 || year_parsed >= currentyear - 7))
		{
			error_obj.global = "Votre année de naissance est suspecte !"
			error = true
		}
		if (error === true)
			this.setState({ error: error_obj })
		return (!error) ? true : false
	}

	submitBirthdate = (event) => {
		event.preventDefault()
		if (this._validateForm2())
		{
			let day = Number(this.state.form2.day)
			if (day < 10)
				day = '0' + day
			let month = Number(this.state.form2.month)
			if (month < 10)
				month = '0' + month
			const birthday = day + "/" + month + "/" + this.state.form2.year
			const user = {
				...this.state.user,
				birthday: birthday
			}
			let step = 4
			if (!this.state.from_recap) {
				if (!this.state.user.phone)
					step = 2
				else if (this.props.service_benefit.questions.length > 0)
					step = 3
			}
			let update_birthday = {
				_id: this.props.user._id,
				birthday: birthday
			}
			this.props.postUpdateBirthday(update_birthday)
			.then(ret => {
				if (ret !== false)
					this.goToStep(step, { error: null, user: user, from_recap: false })
				else
					this.setErrorMsg("Une erreur s'est produite")
			})
		}
	}

	handlePhone = (event) => {
		const form3 = {
			...this.state.form3,
			phone: event.target.value
		}
		this.setState({ form3: form3 })
	}

	submitPhone = (event) => {
		event.preventDefault()
		const phone = this.state.form3.phone
		if (phone.length === 0)
			this.setErrorMsg("Champ obligatoire")
		else
		{
			const user = {
				...this.state.user,
				phone: phone
			}
			let step = 4
			if (!this.state.from_recap && this.props.service_benefit.questions.length > 0)
				step = 3
			let update_phone = {
				_id: this.props.user._id,
				phone: phone
			}
			this.props.postUpdatePhone(update_phone)
			.then(ret => {
				if (ret !== false)
					this.goToStep(step, { error: null, user: user, from_recap: false })
				else
					this.setErrorMsg("Une erreur s'est produite")
			})
		}
	}

	handleAnswer = (event) => {
		const question_nb = this.state.question_nb
		let answers = this.state.answers
		answers[question_nb] = event.target.value
		this.setState({ answers: answers })
	}

	submitAnswers = (event) => {
		event.preventDefault()
		const question_nb = this.state.question_nb
		const question = this.props.service_benefit.questions[question_nb]
		const answer = this.state.answers[question_nb]
		if (question.mandatory === true && answer.length === 0)
			this.setErrorMsg(this.props.lang_assets.services.error_question)
		else
		{
			if (question_nb + 1 === this.state.answers.length)
			{
				let reservation = this.state.reservation
				reservation.answers = this.state.answers
				this.goToStep(4, { reservation: reservation, question_nb: 0 })
			}
			else
			{
				this.clearFlash()
				this.setState({ question_nb: question_nb + 1 })
			}
		}
	}

	// Nombre de participants facturés : le titulaire (si inscrit) + accompagnants.
	_participantsCount = () => {
		let count = (this.state.form1.self === true) ? 1 : 0
		count += this.state.participants.length
		return count
	}

	confirmBooking = () => {
		const total = Number(this.props.service_benefit.price) * this._participantsCount()
		const service = this.state.service
		// Paiement in-app selon le paramétrage du service : "cb_only" force le
		// checkout CB, "cb_optional" laisse le vacancier choisir CB ou sur place
		// (sauf seuils min/max qui imposent l'un ou l'autre), sinon (null/undefined
		// ou prestation gratuite) le paiement reste géré sur place.
		const payment_case = tools.getServicePaymentCase(service, total)
		if (payment_case === 'cb')
		{
			this._startCheckout()
			return
		}
		if (payment_case === 'choice')
		{
			this.setState({ payment_choice: true, stripeError: null })
			return
		}
		this._submitReservation()
	}

	choosePayNow = () => {
		this.setState({ payment_choice: false })
		this._startCheckout()
	}

	choosePayOnSite = () => {
		this.setState({ payment_choice: false })
		this._submitReservation()
	}

	// Paiement CB embarqué : crée le PaymentIntent puis ouvre le modal Checkout.
	// Si le camping n'est pas connecté à Stripe, on retombe sur le flux manuel.
	_startCheckout = () => {
		const payment = this.props.lang_assets.services.payment
		this.setState({ attempt_submit: true, stripeError: null })
		this.props.createBenefitPaymentIntent({
			service_benefit: this.props.service_benefit._id,
			self: this.state.form1.self,
			participants: this.state.participants,
			client_number: this.state.user.client_number,
			user: this.state.reservation.user
		})
		.then(res => {
			if (res && res.client_secret)
			{
				this.setState({ checkout: res, attempt_submit: false })
				return
			}
			if (res && (res.error === 'account_not_ready' || res.error === 'stripe_not_configured' || res.error === 'below_minimum'))
			{
				this._submitReservation()
				return
			}
			this.setState({ attempt_submit: false, stripeError: payment.error_generic })
		})
		.catch(err => {
			this.setState({ attempt_submit: false, stripeError: payment.error_generic })
			console.log(err)
		})
	}

	_submitReservation = (stripe_payment_intent_id = null) => {
		const reservation = {
			...this.state.reservation,
			self: this.state.form1.self,
			participants: this.state.participants,
			client_number: this.state.user.client_number,
			identity: this.state.user.identity,
			age: this.state.user.age,
			phone: this.state.user.phone
		}
		if (stripe_payment_intent_id != null)
			reservation.stripe_payment_intent_id = stripe_payment_intent_id
		this.setState({ attempt_submit: true, stripeError: null, checkout: null })
		this.props.postServiceReservation(reservation)
		.then(res => {
			const payment = this.props.lang_assets.services.payment
			if (res && res.error === 'foreign_card')
			{
				this.setState({ attempt_submit: false, stripeError: payment.error_foreign_card })
				return
			}
			if (res && res.error === 'payment_required')
			{
				this.setState({ attempt_submit: false, stripeError: payment.error_payment_required })
				return
			}
			if (res && res.error === 'full')
			{
				this.setState({ attempt_submit: false, error: { global: payment.error_full } })
				return
			}
			if (res === false || (res && res.error))
			{
				this.setState({ attempt_submit: false, error: { global: "Une erreur s'est produite. Veuillez réessayer." } })
				return
			}
			if (this.props.updateCustomBack)
				this.props.updateCustomBack(null)
			this.setState({ step: 7, attempt_submit: false })
		})
		.catch(err => {
			this.setState({ attempt_submit: false, error: { global: "Une erreur s'est produite. Veuillez réessayer." } })
			console.log(err)
		})
	}

	// STEP 0 : Accueil réservation
	// STEP 1 : Question date de naissance
	// STEP 2 : Question tel
	// STEP 3 : Question texte / nb
	// STEP 4 : Recap
	// STEP 7 : Confirmation

	render() {
		const service_benefit = this.props.service_benefit
		const lang_assets = this.props.lang_assets.services
		if (service_benefit)
		{
			const themeColor = '#' + this.props.theme.color1

			if (this.state.step === 0) //PAGE ACCUEIL RESERVATION
			{
				const participants = this.state.form1.participants
				const selfSelected = this.state.form1.self
				return (
					<div className="min-h-4/5-screen">
						<div className="flex justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<div className="text-white text-3xl">
								<h1>Participants</h1>
							</div>
						</div>
						<div className="bg-white w-full pt-10 px-5 mt-32 min-h-9/10-screen absolute rounded-t-3xl pb-10">
							<div className="px-2.5 pt-5 pb-10">
								<form onSubmit={this.submitParticipants}>

									{/* Carte "Vous" */}
									<div
										className="relative mt-5 rounded-xl px-5 py-4 flex items-center space-x-3 cursor-pointer transition-all"
										style={selfSelected ? {
											backgroundColor: themeColor + '15',
											border: '2px solid ' + themeColor
										} : {
											backgroundColor: '#f3f4f6',
											border: '2px solid transparent'
										}}
										onClick={this.handleSelf}
									>
										<span className="h-11 w-11 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: themeColor + '25' }}>
											<UserCircleIcon className="h-9 w-9" style={{ color: themeColor }}/>
										</span>
										<div className="flex-1 min-w-0">
											<p className="text-base font-semibold text-gray-900">Vous</p>
											<p className="text-sm text-gray-500 truncate">{this.state.user.identity}</p>
										</div>
										<div className="h-6 w-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all"
											style={selfSelected ? { backgroundColor: themeColor, borderColor: themeColor } : { borderColor: '#d1d5db' }}>
											{selfSelected && (
												<svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
													<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
												</svg>
											)}
										</div>
									</div>

									{/* Liste des participants ajoutés */}
									{participants.map(({ firstname, lastname }, id) => {
										if (this.state.editingParticipant === id) {
											return (
												<div key={id} className="relative mt-4 rounded-xl bg-gray-50 px-5 py-4" style={{ border: '2px solid ' + themeColor }}>
													<div className="grid grid-cols-2 gap-3 mb-3">
														<div>
															<label className="block text-xs font-medium text-gray-500 mb-1">Prénom</label>
															<input
																type="text"
																autoFocus
																className="block w-full text-sm py-2 px-3 border border-gray-300 rounded-lg"
																onChange={this.handleFirstname.bind(this, id)}
																value={firstname}
															/>
														</div>
														<div>
															<label className="block text-xs font-medium text-gray-500 mb-1">Nom</label>
															<input
																type="text"
																className="block w-full text-sm py-2 px-3 border border-gray-300 rounded-lg"
																onChange={this.handleLastname.bind(this, id)}
																value={lastname}
															/>
														</div>
													</div>
													<div className="flex gap-2">
														<button type="button" onClick={this.cancelEditParticipant} className="flex-1 py-2 rounded-full text-sm border border-gray-300 text-gray-600">Annuler</button>
														<button type="button" onClick={this.cancelEditParticipant} className="flex-1 py-2 rounded-full text-sm text-white font-semibold" style={{ backgroundColor: themeColor }}>✓ Appliquer</button>
														<button type="button" onClick={this.deleteParticipant.bind(this, id)} className="py-2 px-3 rounded-full border border-red-200 text-red-400">
															<TrashIcon className="h-4 w-4"/>
														</button>
													</div>
												</div>
											)
										}
										return (
											<div
												key={id}
												className="relative mt-4 rounded-xl bg-gray-100 px-5 py-4 flex items-center space-x-3"
											>
												<span className="h-11 w-11 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: themeColor + '25' }}>
													<UserCircleIcon className="h-9 w-9" style={{ color: themeColor }}/>
												</span>
												<div className="flex-1 min-w-0">
													<p className="text-base font-semibold text-gray-900">{firstname} {lastname}</p>
												</div>
												<button type="button" onClick={() => this.setState({ editingParticipant: id })} className="p-2 text-gray-400 hover:text-gray-600">
													<PencilAltIcon className="h-5 w-5"/>
												</button>
											</div>
										)
									})}

									{/* Formulaire inline d'ajout OU bouton Ajouter */}
									{this.state.addingParticipant ? (
										<div className="relative mt-4 rounded-xl bg-gray-50 px-5 py-4" style={{ border: '2px solid ' + themeColor }}>
											<div className="grid grid-cols-2 gap-3 mb-3">
												<div>
													<label className="block text-xs font-medium text-gray-500 mb-1">Prénom</label>
													<input
														type="text"
														autoFocus
														className="block w-full text-sm py-2 px-3 border border-gray-300 rounded-lg"
														onChange={this.handleNewFirstname}
														value={this.state.newParticipant.firstname}
													/>
												</div>
												<div>
													<label className="block text-xs font-medium text-gray-500 mb-1">Nom</label>
													<input
														type="text"
														className="block w-full text-sm py-2 px-3 border border-gray-300 rounded-lg"
														onChange={this.handleNewLastname}
														value={this.state.newParticipant.lastname}
													/>
												</div>
											</div>
											<div className="flex gap-2">
												<button type="button" onClick={this.cancelAddParticipant} className="flex-1 py-2 rounded-full text-sm border border-gray-300 text-gray-600">Annuler</button>
												<button type="button" onClick={this.submitNewParticipant} className="flex-1 py-2 rounded-full text-sm text-white font-semibold" style={{ backgroundColor: themeColor }}>✓ Appliquer</button>
											</div>
										</div>
									) : (
										<div
											className="relative mt-4 rounded-xl bg-gray-100 px-5 py-4 flex items-center space-x-3 cursor-pointer"
											onClick={this.startAddParticipant}
										>
											<span className="h-11 w-11 rounded-full flex items-center justify-center flex-shrink-0 bg-white">
												<PlusSmIcon className="h-7 w-7 text-gray-400"/>
											</span>
											<div className="flex-1 min-w-0">
												<p className="text-base font-medium text-gray-900">Ajouter un participant</p>
												<p className="text-sm text-gray-500">Famille, amis...</p>
											</div>
										</div>
									)}

									{this.state.error && this.state.error.global && (
										<p className="text-sm text-red-400 mt-4">{this.state.error.global}</p>
									)}

									<button type="submit" className="font-semibold py-5 w-full rounded-full text-white shadow-xl text-xl my-10 waves-effect waves-light" style={{ backgroundColor: themeColor }}>Continuer</button>
								</form>
							</div>
						</div>
					</div>
				)
			}
			else if (this.state.step === 1) // QUESTION DATE DE NAISSANCE
			{
				const error = this.state.error ? this.state.error.global : null
				const errorHtml = error ? (
					<div className="flex items-center gap-2 mt-6 text-red-500 text-sm">
						<XCircleIcon className="h-5 w-5 flex-shrink-0" />
						<span>{error}</span>
					</div>
				) : null
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>Pour vous identifier</p>
							<h1 className="text-white text-2xl font-bold mt-1">Date de naissance</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl pb-20">
							<form onSubmit={this.submitBirthdate} className="px-6 pt-12">
								<div className="flex gap-4 justify-center">
									<div className="flex flex-col items-center">
										<input
											type="number"
											placeholder="JJ"
											value={this.state.form2.day}
											onChange={this.handleDay}
											className="date-field w-20 h-20 text-center text-3xl font-bold border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
											style={this.state.form2.day ? { borderColor: themeColor, color: themeColor } : {}}
										/>
										<span className="text-xs text-gray-400 mt-2">Jour</span>
									</div>
									<div className="flex flex-col items-center">
										<input
											type="number"
											placeholder="MM"
											id="month"
											onChange={this.handleMonth}
											className="date-field w-20 h-20 text-center text-3xl font-bold border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
											style={this.state.form2.month ? { borderColor: themeColor, color: themeColor } : {}}
										/>
										<span className="text-xs text-gray-400 mt-2">Mois</span>
									</div>
									<div className="flex flex-col items-center">
										<input
											type="number"
											placeholder="AAAA"
											id="year"
											onChange={this.handleYear}
											className="date-field w-28 h-20 text-center text-3xl font-bold border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
											style={this.state.form2.year ? { borderColor: themeColor, color: themeColor } : {}}
										/>
										<span className="text-xs text-gray-400 mt-2">Année</span>
									</div>
								</div>
								{errorHtml}
								<button type="submit" className="font-semibold py-5 w-full rounded-full text-white shadow-xl text-base waves-effect waves-light mt-16" style={{ backgroundColor: themeColor }}>{lang_assets.button3}</button>
							</form>
						</div>
					</div>
				)
			}
			else if (this.state.step === 2) // QUESTION TELEPHONE
			{
				const error = this.state.error ? this.state.error.global : null
				const errorHtml = error ? (
					<div className="flex items-center gap-2 mt-6 text-red-500 text-sm">
						<XCircleIcon className="h-5 w-5 flex-shrink-0" />
						<span>{error}</span>
					</div>
				) : null
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>Comment vous joindre ?</p>
							<h1 className="text-white text-2xl font-bold mt-1">Téléphone</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl pb-20">
							<form onSubmit={this.submitPhone} className="px-6 pt-12">
								<p className="text-gray-400 text-sm text-center mb-6">En cas de modification ou d'annulation</p>
								<input
									type="tel"
									placeholder="+33 6 00 00 00 00"
									value={this.state.form3.phone}
									onChange={this.handlePhone}
									autoFocus
									className="block w-full text-xl font-semibold text-center py-5 px-4 border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
									style={this.state.form3.phone ? { borderColor: themeColor, color: themeColor } : {}}
								/>
								{errorHtml}
								<button type="submit" className="font-semibold py-5 w-full rounded-full text-white shadow-xl text-base waves-effect waves-light mt-12" style={{ backgroundColor: themeColor }}>{lang_assets.button3}</button>
							</form>
						</div>
					</div>
				)
			}
			else if (this.state.step === 3 && this.state.answers.length > 0) // QUESTIONS TYPE TEXTE / NB
			{
				let question_nb = this.state.question_nb
				const answer = this.state.answers[question_nb]
				const question = service_benefit.questions[question_nb]
				let title = ""
				for (let i = 0; i < question.translations.length; i++)
				{
					if (question.translations[i].lang === this.props.user.lang)
					{
						title = question.translations[i].title
						break
					}
				}
				const error = this.state.error ? this.state.error.global : null
				const errorHtml = error ? (
					<div className="flex items-center gap-2 mt-4 text-red-500 text-sm">
						<XCircleIcon className="h-5 w-5 flex-shrink-0" />
						<span>{error}</span>
					</div>
				) : null
				question_nb++
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36 px-6" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{lang_assets.question} {question_nb} / {this.state.answers.length}</p>
							<div className="flex gap-2 mt-3">
								{this.state.answers.map((_, i) => (
									<div key={i} className="rounded-full transition-all" style={{
										width: i === this.state.question_nb - 1 ? 20 : 8,
										height: 8,
										backgroundColor: i === this.state.question_nb - 1 ? 'white' : 'rgba(255,255,255,0.4)'
									}} />
								))}
							</div>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl pb-20">
							<form onSubmit={this.submitAnswers} className="px-6 pt-10">
								<h2 className="text-2xl font-bold text-gray-800 mb-8 leading-snug">
									{title}{question.mandatory ? <span className="text-red-400"> *</span> : null}
								</h2>
								{question.type === "number" ? (
									<input
										type="number"
										autoFocus
										className="date-field block w-full text-xl text-center py-5 px-4 border-2 border-gray-200 rounded-2xl focus:outline-none transition-colors"
										onChange={this.handleAnswer}
										value={answer}
									/>
								) : (
									<textarea
										rows={5}
										autoFocus
										className="block w-full text-lg text-gray-700 py-4 px-4 border-2 border-gray-200 rounded-2xl focus:outline-none resize-none"
										value={answer}
										onChange={this.handleAnswer}
									/>
								)}
								{errorHtml}
								<button type="submit" className="font-semibold py-5 w-full rounded-full text-white shadow-xl text-base waves-effect waves-light mt-10" style={{ backgroundColor: themeColor }}>{lang_assets.button3}</button>
							</form>
						</div>
					</div>
				)
			}
			else if (this.state.step === 4 && service_benefit) //RECAP
			{
				const reservation = this.state.reservation
				const start = new Date(reservation.start * 1000)
				let start_hour = start.getHours()
				if (start_hour < 10)
					start_hour = '0' + start_hour
				let start_minute = start.getMinutes()
				if (start_minute < 10)
					start_minute = '0' + start_minute
				const end = new Date(reservation.end * 1000)
				let end_hour = end.getHours()
				if (end_hour < 10)
					end_hour = '0' + end_hour
				let end_minute = end.getMinutes()
				if (end_minute < 10)
					end_minute = '0' + end_minute
				const weekday = this.props.lang_assets.time.weekdays[start.getDay()]
				let day = start.getDate()
				if (day < 10)
					day = '0' + day
				const monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
				const monthName = monthNames[start.getMonth()]
				const year = start.getFullYear()
				const benefitTr = tools.mergeTranslation(service_benefit.translations, this.props.user.lang)
				let subtitle = benefitTr.subtitle || ""
				let comment = benefitTr.comment || ""
				let location = benefitTr.location || ""
				// Total = prix unitaire × participants (titulaire + accompagnants).
				const nb_participants = this._participantsCount()
				const total_price = Number(service_benefit.price) * nb_participants
				let price = lang_assets.free
				if (total_price > 0)
				{
					price = total_price.toFixed(2).replace('.', ',') + "€"
					if (nb_participants > 1)
						price = nb_participants + " × " + Number(service_benefit.price).toFixed(2).replace('.', ',') + "€ = " + price
				}
				let commentJSX = null
				if (comment && comment.length > 0)
					commentJSX = (<div className="mx-4 mt-5 service wysiwyg" dangerouslySetInnerHTML={{ __html: comment }}></div>)
				const payment_case = tools.getServicePaymentCase(this.state.service, total_price)
				let confirm_label = lang_assets.button2
				if (payment_case === 'cb')
					confirm_label = lang_assets.button_cb
				else if (payment_case === 'choice')
					confirm_label = lang_assets.button_continue
				let buttonJSX = (<button type="button" onClick={this.confirmBooking} className="font-semibold py-4 w-full rounded-full text-white text-base waves-effect waves-light" style={{ backgroundColor: themeColor }}>{confirm_label}</button>)
				if (this.state.attempt_submit === true)
				{
					buttonJSX = (
						<div className="flex justify-center py-2">
							<Loader />
						</div>
					)
				}
				const identityParts = (this.state.user.identity || "").trim().split(" ")
				const selfInitials = identityParts.map(p => p[0] || "").join("").slice(0, 2).toUpperCase()
				const questionTitles = (service_benefit.questions || []).map(q => {
					for (let i = 0; i < q.translations.length; i++)
					{
						if (q.translations[i].lang === this.props.user.lang)
							return q.translations[i].title
					}
					return q.translations[0] ? q.translations[0].title : ""
				})
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>Vérifiez avant de confirmer</p>
							<h1 className="text-white text-2xl font-bold mt-1">Votre inscription</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl" style={{ paddingBottom: 'calc(var(--vh, 1vh) * 10 + 5rem)' }}>
							<div className="mx-4 mt-6 rounded-2xl overflow-hidden shadow-sm border border-gray-100">
								<div className="px-5 py-4" style={{ backgroundColor: themeColor + "18" }}>
									<h2 className="text-xl font-bold" style={{ color: themeColor }}>{subtitle}</h2>
									{location ? (
										<div className="flex items-center mt-1">
											<LocationMarkerIcon className="w-4 h-4 mr-1 flex-shrink-0" style={{ color: themeColor, opacity: 0.6 }} />
											<span className="text-sm" style={{ color: themeColor, opacity: 0.7 }}>{location}</span>
										</div>
									) : null}
								</div>
								<div className="border-t border-dashed border-gray-200" />
								<div className="px-5 py-4 bg-white">
									<div className="text-base font-medium text-gray-600 capitalize">{weekday} {day} {monthName} {year}</div>
									<div className="flex items-center justify-between mt-3">
										<div className="flex items-center gap-3">
											<span className="text-2xl font-bold text-gray-800">{start_hour}:{start_minute}</span>
											<span className="text-gray-400 text-lg">→</span>
											<span className="text-2xl font-bold text-gray-800">{end_hour}:{end_minute}</span>
										</div>
										<span className="text-sm font-semibold px-3 py-1 rounded-full text-white" style={{ backgroundColor: themeColor }}>{price}</span>
									</div>
								</div>
							</div>
							<div className="mx-4 mt-6">
								<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Participants</div>
								<div className="flex items-center gap-3 py-2">
									<div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: themeColor }}>{selfInitials}</div>
									<div className="text-base font-semibold text-gray-800">{this.state.user.identity}</div>
								</div>
								{this.state.form1.participants.map(({ firstname, lastname }, id) => {
									const pInitials = ((firstname[0] || "") + (lastname[0] || "")).toUpperCase()
									return (
										<div key={id} className="flex items-center gap-3 py-2">
											<div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{ backgroundColor: themeColor }}>{pInitials}</div>
											<div className="text-base font-semibold text-gray-800">{firstname} {lastname}</div>
										</div>
									)
								})}
							</div>
							{(service_benefit.identity || service_benefit.client_number || service_benefit.age || service_benefit.phone) && (
					<div className="mx-4 mt-6">
						<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Vos informations</div>
						<div className="space-y-2">
							{service_benefit.identity && (
								<div className="rounded-xl bg-gray-50 px-4 py-3">
									<div className="text-xs text-gray-400">Identité</div>
									<div className="text-base font-medium text-gray-800 mt-0.5">{this.state.user.identity || "—"}</div>
								</div>
							)}
							{service_benefit.client_number && this.state.user.client_number > 0 && (
								<div className="rounded-xl bg-gray-50 px-4 py-3">
									<div className="text-xs text-gray-400">Numéro client</div>
									<div className="text-base font-medium text-gray-800 mt-0.5">{this.state.user.client_number}</div>
								</div>
							)}
							{service_benefit.age && (
								<div className="rounded-xl bg-gray-50 px-4 py-3 flex items-center justify-between">
									<div>
										<div className="text-xs text-gray-400">Âge</div>
										<div className="text-base font-medium text-gray-800 mt-0.5">{this.state.user.age ? this.state.user.age + " ans" : "—"}</div>
									</div>
									<button type="button" onClick={() => this.goToStep(1, { from_recap: true })} className="text-sm font-semibold" style={{ color: themeColor }}>Modifier</button>
								</div>
							)}
							{service_benefit.phone && (
								<div className="rounded-xl bg-gray-50 px-4 py-3 flex items-center justify-between">
									<div>
										<div className="text-xs text-gray-400">Téléphone</div>
										<div className="text-base font-medium text-gray-800 mt-0.5">{this.state.user.phone || "—"}</div>
									</div>
									<button type="button" onClick={() => this.goToStep(2, { from_recap: true })} className="text-sm font-semibold" style={{ color: themeColor }}>Modifier</button>
								</div>
							)}
						</div>
					</div>
				)}
				{this.state.answers.length > 0 ? (
								<div className="mx-4 mt-6">
									<div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Vos réponses</div>
									<div className="space-y-2">
										{this.state.answers.map((ans, i) => (
											<div key={i} className="rounded-xl bg-gray-50 px-4 py-3">
												<div className="text-xs text-gray-400">{questionTitles[i]}</div>
												<div className="text-base font-medium text-gray-800 mt-0.5">{ans || "—"}</div>
											</div>
										))}
									</div>
								</div>
							) : null}
							{commentJSX}
							{this.state.stripeError && (
								<div className="mx-4 mt-4 rounded-2xl bg-red-50 border border-red-200 px-4 py-3">
									<p className="text-sm font-medium text-red-600">{this.state.stripeError}</p>
								</div>
							)}
							{this.state.error && this.state.error.global && (
								<div className="mx-4 mt-4 rounded-2xl bg-red-50 border border-red-200 px-4 py-3">
									<p className="text-sm font-medium text-red-600">{this.state.error.global}</p>
								</div>
							)}
							<div className="fixed left-0 right-0 bg-white border-t border-gray-100 px-4 py-4" style={{ bottom: 'calc(var(--vh, 1vh) * 10)' }}>
								{buttonJSX}
							</div>

							{this.state.payment_choice && (
								<PaymentChoice
									assets={this.props.lang_assets.services.payment}
									themeColor={themeColor}
									amountLabel={price}
									onPayNow={this.choosePayNow}
									onPayOnSite={this.choosePayOnSite}
									onClose={() => this.setState({ payment_choice: false })}
								/>
							)}

							{this.state.checkout && (
								<Checkout
									publishable_key={this.state.checkout.publishable_key}
									client_secret={this.state.checkout.client_secret}
									themeColor={themeColor}
									amountLabel={(this.state.checkout.amount_total / 100).toFixed(2).replace('.', ',') + "€"}
									lang={this.props.user.lang}
									assets={this.props.lang_assets.services.payment}
									onPaid={(payment_intent_id) => this._submitReservation(payment_intent_id)}
									onClose={() => this.setState({ checkout: null })}
								/>
							)}
						</div>
					</div>
				)
			}
			else if (this.state.step === 7) //CONFIRMATION FINALE
			{
				const bodymovinOptions = {
					loop: false,
					autoplay: true,
					prerender: true,
					animationData: animation
				}
				const resStart = new Date(this.state.reservation.start * 1000)
				const resWeekday = this.props.lang_assets.time.weekdays[resStart.getDay()]
				let resDay = resStart.getDate()
				if (resDay < 10) resDay = "0" + resDay
				const resMonthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
				const resMonthName = resMonthNames[resStart.getMonth()]
				let resHour = resStart.getHours()
				if (resHour < 10) resHour = "0" + resHour
				let resMin = resStart.getMinutes()
				if (resMin < 10) resMin = "0" + resMin
				const resTr = tools.mergeTranslation(service_benefit.translations, this.props.user.lang)
				let resSubtitle = resTr.subtitle || ""
				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-36" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{resSubtitle}</p>
							<h1 className="text-white text-2xl font-bold mt-1">C'est confirmé !</h1>
						</div>
						<div className="bg-white w-full mt-32 min-h-9/10-screen absolute rounded-t-3xl px-6" style={{ paddingBottom: 'calc(var(--vh, 1vh) * 10 + 2rem)' }}>
							<div className="flex flex-col items-center pt-10">
								<div className="w-40">
									<ReactBodymovin options={bodymovinOptions} />
								</div>
								<h2 className="text-3xl font-bold mt-4" style={{ color: themeColor }}>Merci !</h2>
								<p className="text-lg font-medium text-gray-500 mt-2 text-center">{lang_assets.confirm_msg}</p>
								<div className="mt-6 px-5 py-3 rounded-2xl bg-gray-50 w-full text-center">
									<p className="text-base font-semibold text-gray-800">{resSubtitle}</p>
									<p className="text-sm text-gray-400 mt-0.5 capitalize">{resWeekday} {resDay} {resMonthName} · {resHour}:{resMin}</p>
								</div>
							</div>
							<div className="mt-8 flex flex-col gap-3">
								<Link to="/" className="block w-full text-center font-semibold py-4 rounded-full text-white text-base waves-effect waves-light" style={{ backgroundColor: themeColor }}>Retour à l'accueil</Link>
								<Link to="/membres/reservations" className="block w-full text-center font-semibold py-4 rounded-full text-base border-2 text-gray-600" style={{ borderColor: themeColor }}>Voir mes réservations</Link>
							</div>
						</div>
					</div>
				)
			}
			else
			{
				return (
					<div className="loading">
						<Loader />
					</div>
				)
			}
		}
		else
		{
			return (
				<div className="loading">
					<Loader />
				</div>
			)
		}
	}
}

export default Booking
